import React from "react";

import {
    BsLinkedin,
    BsGoogle,
    BsGithub,
} from "react-icons/bs";

import "../styles/footer.scss";

export default function Footer() {

    let sections = [
        { "name": "Skills", "link": "services" },
        { "name": "Projects", "link": "packages" },
        { "name": "Contact", "link": "how-we-work" },
        { "name": "About", "link": "portfolio" },
        { "name": "Home", "link": "home" }
    ];

    // Nav Link Scroll To Section
    let navLinkScrollToSection = (section: any) => {
        let element = document.getElementById(section);
        element?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className="footer-wrapper">
            <footer className="px-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="brand">
                     
                            </div>
                        </div>
                        <div className="col-md-4 mt-4 mt-md-0">
                            <h3 className="h5 heading-color mb-1 text-center text-md-start mb-3">Quick Links</h3>
                            <div className="d-flex flex-column align-items-center align-items-md-start gap-2">
                                {sections.map((section, index) => {
                                    return (
                                        <a href="https://techsynergysquad.com"
                                            onClick={(event) => {
                                                event.preventDefault();
                                                navLinkScrollToSection(section.link);
                                            }} 
                                            className="link text-capitalize" key={index} aria-current="page">{section.name}</a>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="col-md-4 mt-4 mt-md-0">
                            <h3 className="h5 heading-color mb-1 text-center text-md-start mb-3">Follow Me On</h3>
                            <div className="d-flex justify-content-md-start justify-content-center align-items-center gap-2">
                                <a href="https://github.com/yashal-ali" target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-outline-theme social-icon facebook rounded-circle d-flex justify-content-center align-items-center"><BsGithub /></a>
                                <a href="https://www.linkedin.com/in/yashal-ali-53637a24a/" target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-outline-theme social-icon linkedin rounded-circle d-flex justify-content-center align-items-center"><BsLinkedin /></a>
                                <a href="yashalalifarooqui30@gmail.com" target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-outline-theme social-icon twitter rounded-circle d-flex justify-content-center align-items-center"><BsGoogle /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="bottom-line mt-3">
                <div className="container">
                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
                        <p className="m-0">Made with ❤️ by Yashal Ali</p>
                        <p className="m-0">© 2023. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}